<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Datatable,
		},
		data () {
			return {
				//
			}
		},
	}	
</script>


// WEBPACK FOOTER //
// src/components/agreements/views/Index.vue